export default __webpack_public_path__ + "static/media/3.2d969190.png";